import { retainTimes, runoutTimes } from '@constants/orderDispatch'
import { GraviButton, Horizontal, Vertical } from '@gravitate-js/excalibrr'
import { Button, Col, Row } from 'antd'
import React from 'react'

/** @deprecated - Should use OrderManagement/Grid/Filters/DispatchWindow/index.tsx instead */
export const DispatchWindowFilter = ({ onClick, retainValue, runoutValue, isAm, onClear, isOnDemand }) => {
  return (
    <Vertical className='p-3' style={{ minWidth: 350 }}>
      <Horizontal style={{ gap: '1rem' }}>
        <RetainButtons onClick={onClick} selectedButton={retainValue} isAm={isAm} isOnDemand={isOnDemand} />
        <RunoutButtons onClick={onClick} selectedButton={runoutValue} isOnDemand={isOnDemand} />
      </Horizontal>
      <div className='p-3 actions top-border'>
        <GraviButton style={{ width: '100%' }} size='small' theme3 buttonText='Clear' onClick={() => onClear()} />
      </div>
    </Vertical>
  )
}

const RetainButtons = ({ onClick, selectedButton, isAm, isOnDemand }) => {
  const firstButtonText = `${isAm ? 'AM' : 'PM'} Shift Today`
  const secondeButtonText = `${isAm ? 'PM' : 'AM'} Shift ${isAm ? 'Today' : 'Tomorrow'}`
  const firstButtonValue = `${isAm ? retainTimes.AMTODAY : retainTimes.PMTODAY}`
  const secondeButtonValue = `${isAm ? retainTimes.PMTODAY : retainTimes.AMTOMORROW}`

  return (
    <Vertical flex={1} style={{ gap: '0.5rem' }}>
      <b>{isOnDemand ? 'START' : 'RETAIN'}</b>
      <FilterButton text='Now' value={retainTimes.NOW} onClick={onClick} selectedButton={selectedButton} />
      <FilterButton text={firstButtonText} value={firstButtonValue} onClick={onClick} selectedButton={selectedButton} />
      <FilterButton
        text={secondeButtonText}
        value={secondeButtonValue}
        onClick={onClick}
        selectedButton={selectedButton}
      />
    </Vertical>
  )
}

const RunoutButtons = ({ onClick, selectedButton, isOnDemand }) => (
  <Vertical flex={1} style={{ gap: '0.5rem ' }}>
    <b>{isOnDemand ? 'END' : 'RUNOUT'}</b>
    <FilterButton
      text='12 Hours'
      value={runoutTimes.HALFDAY}
      property='runoutTime'
      onClick={onClick}
      selectedButton={selectedButton}
    />
    <FilterButton
      text='24 Hours'
      value={runoutTimes.DAY}
      property='runoutTime'
      onClick={onClick}
      selectedButton={selectedButton}
    />
    <FilterButton
      text='3 Days'
      value={runoutTimes.THREEDAYS}
      property='runoutTime'
      onClick={onClick}
      selectedButton={selectedButton}
    />
    <FilterButton
      text='Next Week'
      value={runoutTimes.WEEK}
      property='runoutTime'
      onClick={onClick}
      selectedButton={selectedButton}
    />
  </Vertical>
)

const FilterButton = ({ text, value, property = 'retainTime', onClick, selectedButton }) => (
  <Button
    size='small'
    className={`${selectedButton && selectedButton.includes(value) ? 'selected' : ''}`}
    onClick={() => onClick(value, property)}
  >
    {text}
  </Button>
)
